/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as RecentMarketInformationImport } from './routes/recent-market-information'
import { Route as PastMarketInformationImport } from './routes/past-market-information'
import { Route as DecisionsImport } from './routes/decisions'
import { Route as IndexImport } from './routes/index'
import { Route as RecentMarketInformationIndexImport } from './routes/recent-market-information/index'
import { Route as UserPasswordImport } from './routes/user/password'
import { Route as UserLoginImport } from './routes/user/login'
import { Route as RecentMarketInformationZoneImport } from './routes/recent-market-information/$zone'
import { Route as PastMarketInformationZoneImport } from './routes/past-market-information/$zone'
import { Route as DecisionsZoneImport } from './routes/decisions/$zone'
import { Route as UserResetUidIndexImport } from './routes/user/reset/$uid/index'
import { Route as UserResetUidTsHashImport } from './routes/user/reset/$uid/$ts.$hash'

// Create/Update Routes

const RecentMarketInformationRoute = RecentMarketInformationImport.update({
  id: '/recent-market-information',
  path: '/recent-market-information',
  getParentRoute: () => rootRoute,
} as any)

const PastMarketInformationRoute = PastMarketInformationImport.update({
  id: '/past-market-information',
  path: '/past-market-information',
  getParentRoute: () => rootRoute,
} as any)

const DecisionsRoute = DecisionsImport.update({
  id: '/decisions',
  path: '/decisions',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const RecentMarketInformationIndexRoute =
  RecentMarketInformationIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => RecentMarketInformationRoute,
  } as any)

const UserPasswordRoute = UserPasswordImport.update({
  id: '/user/password',
  path: '/user/password',
  getParentRoute: () => rootRoute,
} as any)

const UserLoginRoute = UserLoginImport.update({
  id: '/user/login',
  path: '/user/login',
  getParentRoute: () => rootRoute,
} as any)

const RecentMarketInformationZoneRoute =
  RecentMarketInformationZoneImport.update({
    id: '/$zone',
    path: '/$zone',
    getParentRoute: () => RecentMarketInformationRoute,
  } as any)

const PastMarketInformationZoneRoute = PastMarketInformationZoneImport.update({
  id: '/$zone',
  path: '/$zone',
  getParentRoute: () => PastMarketInformationRoute,
} as any)

const DecisionsZoneRoute = DecisionsZoneImport.update({
  id: '/$zone',
  path: '/$zone',
  getParentRoute: () => DecisionsRoute,
} as any)

const UserResetUidIndexRoute = UserResetUidIndexImport.update({
  id: '/user/reset/$uid/',
  path: '/user/reset/$uid/',
  getParentRoute: () => rootRoute,
} as any)

const UserResetUidTsHashRoute = UserResetUidTsHashImport.update({
  id: '/user/reset/$uid/$ts/$hash',
  path: '/user/reset/$uid/$ts/$hash',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/decisions': {
      id: '/decisions'
      path: '/decisions'
      fullPath: '/decisions'
      preLoaderRoute: typeof DecisionsImport
      parentRoute: typeof rootRoute
    }
    '/past-market-information': {
      id: '/past-market-information'
      path: '/past-market-information'
      fullPath: '/past-market-information'
      preLoaderRoute: typeof PastMarketInformationImport
      parentRoute: typeof rootRoute
    }
    '/recent-market-information': {
      id: '/recent-market-information'
      path: '/recent-market-information'
      fullPath: '/recent-market-information'
      preLoaderRoute: typeof RecentMarketInformationImport
      parentRoute: typeof rootRoute
    }
    '/decisions/$zone': {
      id: '/decisions/$zone'
      path: '/$zone'
      fullPath: '/decisions/$zone'
      preLoaderRoute: typeof DecisionsZoneImport
      parentRoute: typeof DecisionsImport
    }
    '/past-market-information/$zone': {
      id: '/past-market-information/$zone'
      path: '/$zone'
      fullPath: '/past-market-information/$zone'
      preLoaderRoute: typeof PastMarketInformationZoneImport
      parentRoute: typeof PastMarketInformationImport
    }
    '/recent-market-information/$zone': {
      id: '/recent-market-information/$zone'
      path: '/$zone'
      fullPath: '/recent-market-information/$zone'
      preLoaderRoute: typeof RecentMarketInformationZoneImport
      parentRoute: typeof RecentMarketInformationImport
    }
    '/user/login': {
      id: '/user/login'
      path: '/user/login'
      fullPath: '/user/login'
      preLoaderRoute: typeof UserLoginImport
      parentRoute: typeof rootRoute
    }
    '/user/password': {
      id: '/user/password'
      path: '/user/password'
      fullPath: '/user/password'
      preLoaderRoute: typeof UserPasswordImport
      parentRoute: typeof rootRoute
    }
    '/recent-market-information/': {
      id: '/recent-market-information/'
      path: '/'
      fullPath: '/recent-market-information/'
      preLoaderRoute: typeof RecentMarketInformationIndexImport
      parentRoute: typeof RecentMarketInformationImport
    }
    '/user/reset/$uid/': {
      id: '/user/reset/$uid/'
      path: '/user/reset/$uid'
      fullPath: '/user/reset/$uid'
      preLoaderRoute: typeof UserResetUidIndexImport
      parentRoute: typeof rootRoute
    }
    '/user/reset/$uid/$ts/$hash': {
      id: '/user/reset/$uid/$ts/$hash'
      path: '/user/reset/$uid/$ts/$hash'
      fullPath: '/user/reset/$uid/$ts/$hash'
      preLoaderRoute: typeof UserResetUidTsHashImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface DecisionsRouteChildren {
  DecisionsZoneRoute: typeof DecisionsZoneRoute
}

const DecisionsRouteChildren: DecisionsRouteChildren = {
  DecisionsZoneRoute: DecisionsZoneRoute,
}

const DecisionsRouteWithChildren = DecisionsRoute._addFileChildren(
  DecisionsRouteChildren,
)

interface PastMarketInformationRouteChildren {
  PastMarketInformationZoneRoute: typeof PastMarketInformationZoneRoute
}

const PastMarketInformationRouteChildren: PastMarketInformationRouteChildren = {
  PastMarketInformationZoneRoute: PastMarketInformationZoneRoute,
}

const PastMarketInformationRouteWithChildren =
  PastMarketInformationRoute._addFileChildren(
    PastMarketInformationRouteChildren,
  )

interface RecentMarketInformationRouteChildren {
  RecentMarketInformationZoneRoute: typeof RecentMarketInformationZoneRoute
  RecentMarketInformationIndexRoute: typeof RecentMarketInformationIndexRoute
}

const RecentMarketInformationRouteChildren: RecentMarketInformationRouteChildren =
  {
    RecentMarketInformationZoneRoute: RecentMarketInformationZoneRoute,
    RecentMarketInformationIndexRoute: RecentMarketInformationIndexRoute,
  }

const RecentMarketInformationRouteWithChildren =
  RecentMarketInformationRoute._addFileChildren(
    RecentMarketInformationRouteChildren,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/decisions': typeof DecisionsRouteWithChildren
  '/past-market-information': typeof PastMarketInformationRouteWithChildren
  '/recent-market-information': typeof RecentMarketInformationRouteWithChildren
  '/decisions/$zone': typeof DecisionsZoneRoute
  '/past-market-information/$zone': typeof PastMarketInformationZoneRoute
  '/recent-market-information/$zone': typeof RecentMarketInformationZoneRoute
  '/user/login': typeof UserLoginRoute
  '/user/password': typeof UserPasswordRoute
  '/recent-market-information/': typeof RecentMarketInformationIndexRoute
  '/user/reset/$uid': typeof UserResetUidIndexRoute
  '/user/reset/$uid/$ts/$hash': typeof UserResetUidTsHashRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/decisions': typeof DecisionsRouteWithChildren
  '/past-market-information': typeof PastMarketInformationRouteWithChildren
  '/decisions/$zone': typeof DecisionsZoneRoute
  '/past-market-information/$zone': typeof PastMarketInformationZoneRoute
  '/recent-market-information/$zone': typeof RecentMarketInformationZoneRoute
  '/user/login': typeof UserLoginRoute
  '/user/password': typeof UserPasswordRoute
  '/recent-market-information': typeof RecentMarketInformationIndexRoute
  '/user/reset/$uid': typeof UserResetUidIndexRoute
  '/user/reset/$uid/$ts/$hash': typeof UserResetUidTsHashRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/decisions': typeof DecisionsRouteWithChildren
  '/past-market-information': typeof PastMarketInformationRouteWithChildren
  '/recent-market-information': typeof RecentMarketInformationRouteWithChildren
  '/decisions/$zone': typeof DecisionsZoneRoute
  '/past-market-information/$zone': typeof PastMarketInformationZoneRoute
  '/recent-market-information/$zone': typeof RecentMarketInformationZoneRoute
  '/user/login': typeof UserLoginRoute
  '/user/password': typeof UserPasswordRoute
  '/recent-market-information/': typeof RecentMarketInformationIndexRoute
  '/user/reset/$uid/': typeof UserResetUidIndexRoute
  '/user/reset/$uid/$ts/$hash': typeof UserResetUidTsHashRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/decisions'
    | '/past-market-information'
    | '/recent-market-information'
    | '/decisions/$zone'
    | '/past-market-information/$zone'
    | '/recent-market-information/$zone'
    | '/user/login'
    | '/user/password'
    | '/recent-market-information/'
    | '/user/reset/$uid'
    | '/user/reset/$uid/$ts/$hash'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/decisions'
    | '/past-market-information'
    | '/decisions/$zone'
    | '/past-market-information/$zone'
    | '/recent-market-information/$zone'
    | '/user/login'
    | '/user/password'
    | '/recent-market-information'
    | '/user/reset/$uid'
    | '/user/reset/$uid/$ts/$hash'
  id:
    | '__root__'
    | '/'
    | '/decisions'
    | '/past-market-information'
    | '/recent-market-information'
    | '/decisions/$zone'
    | '/past-market-information/$zone'
    | '/recent-market-information/$zone'
    | '/user/login'
    | '/user/password'
    | '/recent-market-information/'
    | '/user/reset/$uid/'
    | '/user/reset/$uid/$ts/$hash'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DecisionsRoute: typeof DecisionsRouteWithChildren
  PastMarketInformationRoute: typeof PastMarketInformationRouteWithChildren
  RecentMarketInformationRoute: typeof RecentMarketInformationRouteWithChildren
  UserLoginRoute: typeof UserLoginRoute
  UserPasswordRoute: typeof UserPasswordRoute
  UserResetUidIndexRoute: typeof UserResetUidIndexRoute
  UserResetUidTsHashRoute: typeof UserResetUidTsHashRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DecisionsRoute: DecisionsRouteWithChildren,
  PastMarketInformationRoute: PastMarketInformationRouteWithChildren,
  RecentMarketInformationRoute: RecentMarketInformationRouteWithChildren,
  UserLoginRoute: UserLoginRoute,
  UserPasswordRoute: UserPasswordRoute,
  UserResetUidIndexRoute: UserResetUidIndexRoute,
  UserResetUidTsHashRoute: UserResetUidTsHashRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/decisions",
        "/past-market-information",
        "/recent-market-information",
        "/user/login",
        "/user/password",
        "/user/reset/$uid/",
        "/user/reset/$uid/$ts/$hash"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/decisions": {
      "filePath": "decisions.tsx",
      "children": [
        "/decisions/$zone"
      ]
    },
    "/past-market-information": {
      "filePath": "past-market-information.tsx",
      "children": [
        "/past-market-information/$zone"
      ]
    },
    "/recent-market-information": {
      "filePath": "recent-market-information.tsx",
      "children": [
        "/recent-market-information/$zone",
        "/recent-market-information/"
      ]
    },
    "/decisions/$zone": {
      "filePath": "decisions/$zone.tsx",
      "parent": "/decisions"
    },
    "/past-market-information/$zone": {
      "filePath": "past-market-information/$zone.tsx",
      "parent": "/past-market-information"
    },
    "/recent-market-information/$zone": {
      "filePath": "recent-market-information/$zone.tsx",
      "parent": "/recent-market-information"
    },
    "/user/login": {
      "filePath": "user/login.tsx"
    },
    "/user/password": {
      "filePath": "user/password.tsx"
    },
    "/recent-market-information/": {
      "filePath": "recent-market-information/index.tsx",
      "parent": "/recent-market-information"
    },
    "/user/reset/$uid/": {
      "filePath": "user/reset/$uid/index.tsx"
    },
    "/user/reset/$uid/$ts/$hash": {
      "filePath": "user/reset/$uid/$ts.$hash.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
